import { prefixerI } from '.'

export const ROUTE_INFORME_SALDOS_ANTICIPO = prefixerI('saldos-anticipos')
export const ROUTE_INFORME_PROVEEDORES_CORTE = prefixerI('proveedores-corte')
export const ROUTE_INFORME_OBLIGACIONES_VENCER_VENCIDAS = prefixerI('obligaciones-vencer-vencidas')
export const ROUTE_INFORME_CARTERA_30_60_90 = prefixerI('cartera-30-60-90')
export const ROUTE_INFORME_ESTADO_CUENTA = prefixerI('estado-cuenta')
export const ROUTE_INFORME_FLUJO_PAGO_PROVEEDOR = prefixerI('flujo-pago-proveedor')
